import { Request } from '../../../httpClient/serverApi/requests/Request';
import { UserNotificationSettingsLayer } from '../../models/UserNotificationSettingsLayer';
import { IGetUserNotificationSettingsResponse } from './IGetUserNotificationSettingsResponse';

export class GetUserNotificationSettingsRequest extends Request<{}, IGetUserNotificationSettingsResponse> {
  constructor(layer: UserNotificationSettingsLayer, siteId?: string) {
    const requestMap: Record<UserNotificationSettingsLayer, string> = {
      [UserNotificationSettingsLayer.User]: 'getNotificationEnabledSettingsForUser',
      [UserNotificationSettingsLayer.Site]: 'getNotificationEnabledSettingsForSite',
      [UserNotificationSettingsLayer.Server]: 'getNotificationEnabledSettingsForServer'
    };

    super(requestMap[layer], siteId ? { siteId: siteId } : {});
  }
}
